export enum LocaleCode {
    Bulgarian = 'bg-BG',
    Croatian = 'hr-HR',
    English = 'en-US',
    Hungarian = 'hu-HU',
    Romanian = 'ro-RO',
    Slovenian = 'sl-SI',
}
